import { eDmMucHocPhiTheoMonActionsObj } from "./../../action-types/category/IDmMucHocPhiTheoMonActions";
import { NotifyHelper } from "../../../helpers/toast";
import { eDmMucHocPhiTheoMonActionIds } from "../../action-types/category/IDmMucHocPhiTheoMonActions";
import { generateActionForKey, generateActions } from "../generateActions";

export const mucHocPhiTheoMonActions = {
  ...generateActions(eDmMucHocPhiTheoMonActionsObj, "MUC_HOC_PHI_THEO_MON"),
  ...generateActionForKey(
    eDmMucHocPhiTheoMonActionIds,
    "MUC_HOC_PHI_THEO_MON",
    "SAVE_SUCCESS",
    () => {
      NotifyHelper.Success("Đã cập nhật");
    }
  ),
  ...generateActionForKey(
    eDmMucHocPhiTheoMonActionIds,
    "MUC_HOC_PHI_THEO_MON",
    "SAVE_ERROR",
    (m: string) => {
      NotifyHelper.Error(m);
    }
  ),
  ...generateActionForKey(
    eDmMucHocPhiTheoMonActionIds,
    "MUC_HOC_PHI_THEO_MON",
    "LOCK_SUCCESS",
    (m: string) => {
      NotifyHelper.Success("Khoá thành công");
    }
  ),
  ...generateActionForKey(
    eDmMucHocPhiTheoMonActionIds,
    "MUC_HOC_PHI_THEO_MON",
    "LOCK_ERRR",
    (m: string) => {
      NotifyHelper.Error(m);
    }
  ),
  ...generateActionForKey(
    eDmMucHocPhiTheoMonActionIds,
    "MUC_HOC_PHI_THEO_MON",
    "UNLOCK_SUCCESS",
    (m: string) => {
      NotifyHelper.Success("Mở khóa thành công");
    }
  ),
  ...generateActionForKey(
    eDmMucHocPhiTheoMonActionIds,
    "MUC_HOC_PHI_THEO_MON",
    "UNLOCK_ERRR",
    (m: string) => {
      NotifyHelper.Error(m);
    }
  ),
  ...generateActionForKey(
    eDmMucHocPhiTheoMonActionIds,
    "MUC_HOC_PHI_THEO_MON",
    "COPY_ERROR",
    (m: string) => {
      NotifyHelper.Error("Sao chép không thành công");
    }
  ),
  ...generateActionForKey(
    eDmMucHocPhiTheoMonActionIds,
    "MUC_HOC_PHI_THEO_MON",
    "COPY_SUCCESS",
    () => {
      NotifyHelper.Success("Sao chép thành công");
    }
  ),
};
